import { TranslationModel } from "models/translation";

export const svTranslations: TranslationModel = {
  yes: "Ja",
  no: "Nej",

  nav_logout: "Logga ut",
  not_found_title: "Hittades inte",

  shared_login: "Logga in",

  privacy_policy: "Integritetspolicy",
  accessibility: "Tillgänglighetsutlåtande",

  locale_fi: "Finska",
  locale_en: "Engelska",
  locale_sv: "Svenska",

  show_in_locale_fi: "På finska",
  show_in_locale_en: "På engelska",
  show_in_locale_sv: "På svenska",

  no_rows: "Inga uppgifter",
  go_back: "Gå tillbaka",

  user_status: "Status",

  login_title: "Logga in",
  login_error: "Inloggningen misslyckades",
  login_or: "Eller",
  login_with_ftn: "Logga in med bankuppgifter",
  login_button: "Logga in",
  login_label_email: "E-post",
  login_label_password: "Lösenord",
  login_link_expired_title: "Länken är ogiltig eller har gått ut",
  login_link_expired_text:
    "Länken du öppnade är ogiltig eller har gått ut. Kontakta listadministratören för att få en ny länk.",
  login_link_p1: "För att uppdatera din information behöver du logga in.",
  login_link_p2:
    "Du kan börja genom att klicka på knappen nedan och identifiera dig med bank-ID.",
  login_begin_auth: "Påbörja identifiering",

  field_datatype_text: "Öppen fält",
  field_datatype_textarea: "Öppen text",
  field_datatype_email: "E-postadress",
  field_datatype_date: "Datum",
  field_datatype_datetime: "Datum och tid",
  field_datatype_dropdown: "Rullgardinsmeny",
  field_datatype_check: "Kryssruta",
  field_datatype_ssn: "Personnummer",
  field_datatype_phone: "Telefonnummer",
  field_datatype_radio: "Flervalsalternativ",

  user_status_draft: "Utkast",
  user_status_invited: "Inbjuden",
  user_status_progress: "Pågående",
  user_status_submitted: "Inskickad",
  user_status_approved: "Godkänd",

  email_filter_all: "Alla",
  email_filter_draft: "Utkast",

  email_template_type_invitation: "Inbjudan",
  email_template_type_reminder: "Påminnelse",
  email_template_type_update_request: "Begäran om uppdatering",
  email_template_type_approved: "Godkänd",
  email_template_type_rejected: "Avslagen",
  email_template_type_custom: "",

  column_type_field: "Fält",
  column_type_name: "Namn",
  column_type_modified: "Ändrad",
  column_type_status: "Status",
  column_type_liabilities: "Förtroende- och ämbetsuppdrag",

  column_width_automatic: "Automatisk",

  pdf_status: "Status",
  pdf_date: "Datum",
  pdf_contains_secret_material: "Contains information classified as secret.",

  validate_required: "Fältet är obligatoriskt.",
  validate_email: "Ogiltig e-postadress.",
  validate_phone: "Ogiltigt telefonnummer.",
  validate_ssn: "Ogiltigt personnummer.",
  validate_password_min8: "Lösenordet måste vara minst 8 tecken långt.",
  validate_localestring_translation_missing: "Saknad översättning",
  validate_password_same_as_old:
    "Lösenordet får inte vara samma som det gamla lösenordet.",
  validate_password_do_not_match: "Lösenorden matchar inte.",

  email_event_type_bounce: "Ogiltig adress",
  email_event_type_click: "Meddelande klickat",
  email_event_type_delivery: "Meddelande skickat",
  email_event_type_open: "Meddelande öppnat",
  email_event_type_reject: "Meddelande avvisat",
  email_event_type_complaint: "Markerad som skräppost",
};
